import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const isMissingEnv =
        !import.meta.env.VITE_SUPABASE_URL ||
        !import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

      return (
        <div style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, sans-serif",
          background: "#faf8f5",
          color: "#333",
          padding: "2rem",
        }}>
          <div style={{ maxWidth: 500, textAlign: "center" }}>
            <h1 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "#6B1D2A" }}>
              {isMissingEnv ? "⚠️ Configuração em falta" : "⚠️ Erro inesperado"}
            </h1>
            {isMissingEnv ? (
              <div style={{ textAlign: "left", lineHeight: 1.8 }}>
                <p>O ficheiro <code>.env</code> não foi encontrado ou está incompleto.</p>
                <p style={{ marginTop: "1rem" }}>Crie o ficheiro <code>.env</code> na raiz do projeto com:</p>
                <pre style={{
                  background: "#f0ede8",
                  padding: "1rem",
                  borderRadius: "8px",
                  fontSize: "0.8rem",
                  overflowX: "auto",
                  marginTop: "0.5rem",
                }}>
{`VITE_SUPABASE_URL=https://yxksoifzgwwzqxrbqkny.supabase.co
VITE_SUPABASE_PUBLISHABLE_KEY=eyJhbGciOiJIUzI1NiIs...`}
                </pre>
                <p style={{ marginTop: "1rem", fontSize: "0.9rem", color: "#666" }}>
                  Depois reinicie o servidor com <code>npm run dev</code>.
                </p>
              </div>
            ) : (
              <div>
                <p>{this.state.error?.message}</p>
                <button
                  onClick={() => window.location.reload()}
                  style={{
                    marginTop: "1rem",
                    padding: "0.5rem 1.5rem",
                    background: "#6B1D2A",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Recarregar
                </button>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
